import Swiper from "swiper";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
const progressCircle = document.querySelector(".autoplay-progress");

const swiper = new Swiper(".swiper", {
  modules: [Autoplay, EffectFade, Pagination],
  loop: true,
  effect: "fade",
  fadeEffect: { crossFade: true },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    autoplayTimeLeft(s, time, progress) {
      progressCircle.style.setProperty(
        "--progress",
        100 - progress * 100 + "%"
      );
    },
  },
});
